<template>
	<div class="view-login">
		<login-form class="view-login__form" :loading="isLoading" :errors="errors" @submit="login" />
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import LoginForm from '@/components/login/LoginForm.vue';
import { ERRORS } from '@/constants/errors/constants';
import { authActions } from '@/store/modules/auth';
import { InstanceApiErrors, mapErrorMessagesToInstance, onApiError } from '@/tools/helpers';

export default defineComponent({
	components: {
		LoginForm,
	},

	data() {
		return {
			errors: {} as InstanceApiErrors,
		};
	},

	computed: {
		isLoading(): boolean {
			return this.$isLoading(['auth/loginWithCredentials']);
		},
	},

	methods: {
		async login(data: FormData) {
			try {
				await authActions.loginWithCredentials({ data });
				await this.$router.push({ name: 'home' });
			} catch (e) {
				onApiError(e, {
					422: error => {
						const { errors = {} } = error.response?.data ?? {};

						mapErrorMessagesToInstance(errors, this.errors);
					},
					default: () => {
						this.$toast.open({
							message: ERRORS.GENERIC_ERROR_MESSAGE,
						});
					},
				});
			}
		},
	},
});
</script>

<style lang="scss">
.view-login {
	display: flex;
	align-items: center;

	&__form {
		@include max-md-and-portrait {
			display: grid;
			grid-template-columns: 1fr 1fr;
		}

		.form__header {
			padding: 0.5rem 0 2rem;

			@include max-md-and-portrait {
				padding: 0;
			}

			@include max-xl {
				padding: 0.5rem 0 4rem;
			}
		}

		.form__content {
			padding: 2rem 0;

			@include max-md-and-portrait {
				padding: 0;
			}
		}
	}
}
</style>
